export default __webpack_public_path__ + "static/media/marketplace-darkGrey.180aa022.svg";